export default {
      id: "ic-canli-izle-green-usage",
      viewBox: "0 0 48 48",
      url: "/" + "images/icons.3.109.2.svg#ic-canli-izle-green-usage",
      toString: function () {
        return this.url;
      }
    }